module.exports = __webpack_public_path__ + "assets/img/loyalty-5.ad9ad8b6.svg";